<template>
  <basic-container>
    <div class="search-contain">
      <el-form ref="query" :model="query" :inline="true" size="mini">
        <el-form-item label="活动名称">
          <el-input placeholder="请输入名称" v-model="query.name" clearable />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="活动时间" prop="daterange">
          <el-date-picker
            v-model="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="创建人">
          <el-input placeholder="请输入" v-model="query.createUser" clearable />
        </el-form-item>
        <el-form-item label="隶属公司" prop="merchantId">
          <YdMerchantSelector v-model="query.merchantId" placeholder="请选择隶属公司" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchChange" :loading="loading"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="searchReset" :loading="loading"
            >清空</el-button
          >
          <el-button
            class="add"
            type="primary"
            @click="addClick"
            icon="el-icon-plus"
            style="margin-right: 40px"
            v-has-permi="['activity_coupon_edit']"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <yd-table
      :loading="loading"
      :data="records"
      border
      size="mini"
      :pagination="pagination"
      @onChange="onTableChange"
    >
      <el-table-column label="活动名称" prop="name" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openDetail(scope.row)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="优惠金额" prop="discountsMoney" align="center" width="80" />
      <el-table-column label="隶属公司" prop="merchantName" align="center" />
      <el-table-column label="开始时间" prop="startTime" align="center" />
      <el-table-column label="结束时间" prop="endTime" align="center" />
      <!-- <el-table-column label="链接" prop="statusStr" align="center" width="100" /> -->
      <el-table-column label="创建人" prop="createUserName" align="center" width="80" />
      <el-table-column label="创建时间" prop="createTime" align="center" />
      <el-table-column label="状态" prop="statusStr" align="center" width="80" />
      <el-table-column label="操作" prop="operate" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getAdvertisingInfo(scope.row.id)"
            v-if="scope.row.status !== 4"
            size="mini"
            v-has-permi="['activity_coupon_edit']"
            >编辑</el-button
          >
          <el-button
            type="text"
            @click="handleStart(scope.row)"
            size="mini"
            v-if="scope.row.status == 5"
            v-has-permi="['activity_coupon_status']"
            >上架</el-button
          >
          <el-button
            type="text"
            @click="handleApprove(scope.row.id)"
            v-if="scope.row.status == 1"
            size="mini"
            v-has-permi="['activity_coupon_review']"
            >通过</el-button
          >
          <el-button
            type="text"
            @click="handleFailed(scope.row.id)"
            v-if="scope.row.status == 1"
            size="mini"
            v-has-permi="['activity_coupon_review']"
            >不通过</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.status == 4"
            @click="handleFinish(scope.row.id)"
            size="mini"
            v-has-permi="['activity_coupon_status']"
            >下架</el-button
          >
        </template>
      </el-table-column>
    </yd-table>
    <activity-edit
      v-if="editVisible"
      :visible="editVisible"
      @saveEdit="saveEdit"
      @closeEdit="closeEdit"
      :advertisingInfo="advertisingInfo"
    />
    <activity-detail ref="activityDetail" />
  </basic-container>
</template>

<script>
  import {
    getReceivePage,
    saveOrUpdate,
    getInfo,
    changeStatus
  } from '@/api/marketing/activities-api'
  import ActivityEdit from './components/activity-edit'
  import ActivityDetail from './components/activity-detail'
  import { mapState } from 'vuex'
  import dayjs from 'dayjs'
  import isBetween from 'dayjs/plugin/isBetween'
  import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

  export default {
    name: 'activityCoupon',
    components: {
      ActivityEdit,
      ActivityDetail
    },
    data() {
      return {
        statusList: [
          { value: 1, label: '待审核' },
          { value: 2, label: '审核未通过' },
          { value: 3, label: '未开始' },
          { value: 4, label: '进行中' },
          { value: 5, label: '已下架' }
        ],
        query: {},
        daterange: [],
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        records: [],
        editVisible: false,
        advertisingInfo: {},
        dataVisible: false,
        loading: false
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.user.userInfo
      })
    },
    created() {
      dayjs.extend(isSameOrAfter)
      dayjs.extend(isBetween)
    },
    mounted() {
      // this.initPage()
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.initPage()
      },
      initPage() {
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0]
          endTime = this.daterange[1]
        }
        const params = {
          startTime,
          endTime,
          ...this.pagination,
          ...this.query,
          type: 1
        }
        this.getReceivePageFetch(params)
      },
      addClick() {
        this.editVisible = true
      },
      saveEdit(form) {
        this.$confirm('是否确定保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.handleSaveOrUpdate(form)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      closeEdit() {
        this.advertisingInfo = {}
        this.editVisible = false
      },
      searchChange() {
        this.pagination = {
          current: 1,
          size: 10,
          total: 0
        }
        this.initPage()
      },
      searchReset() {
        this.daterange = []
        this.query = {}
        this.pagination = {
          current: 1,
          size: 10,
          total: 0
        }
        this.initPage()
      },
      handleSaveOrUpdate(params) {
        this.$loading()
        saveOrUpdate(params)
          .then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success('保存成功！')
              this.editVisible = false
              this.initPage()
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleApprove(id) {
        this.$confirm('确定通过审核吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '稍后再看',
          type: 'warning',
          center: true
        })
          .then(() => {
            const params = {
              id,
              status: 999
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      handleFailed(id) {
        this.$prompt('确定审核不通过吗？', '提示', {
          inputPlaceholder: '请输入不通过原因',
          inputErrorMessage: '请输入不通过原因',
          cancelButtonText: '稍后再看',
          confirmButtonText: '确定',
          inputType: 'textarea',
          inputValidator: (value) => {
            // 带有监听功能监听输入value值 触发return false时输入框会提示inputErrorMessage的内容
            if (!value) {
              return '原因不能为空'
            }
          },
          type: 'warning'
        })
          .then((e) => {
            const params = {
              id,
              status: 2,
              updateUser: this.userInfo.userId
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({ type: 'info', message: '输入错误或已取消' })
          })
      },
      handleStart(obj) {
        const time = new Date()
        const timeInfo = dayjs(time).format('YYYY-MM-DD HH:mm:ss')
        const isSameOrAfter = dayjs(timeInfo).isSameOrAfter(dayjs(obj.endTime), 'day')
        // let isBetween = dayjs(timeInfo).isBetween(obj.startTime, dayjs(obj.endTime),'day', '[]')
        if (isSameOrAfter) {
          this.$message.error('该活动已超过有效期，无法上架！')
          return
        }
        this.$confirm('', '确定上架吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '稍后再看',
          type: 'warning',
          center: true
        })
          .then(() => {
            const params = {
              id: obj.id,
              status: 998,
              updateUser: this.userInfo.userId
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      handleFinish(id) {
        this.$confirm('下架后乘客端不再展示该活动！', '确定下架吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '稍后再看',
          type: 'warning',
          center: true
        })
          .then(() => {
            const params = {
              id,
              status: 5,
              updateUser: this.userInfo.userId
            }
            this.handleChangeStatus(params)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      handleChangeStatus(params) {
        this.$loading()
        changeStatus(params)
          .then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success('操作成功！')
              this.initPage()
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      dataView(obj) {
        this.$refs.dataView.init(obj.id, obj.name)
      },
      openDetail(obj) {
        this.$refs.activityDetail.init(obj.id)
      },
      // 获取广告位分页
      getReceivePageFetch(params) {
        this.loading = true
        getReceivePage(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.records = data.records
              this.total = data.total
              this.pagination.total = data.total
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getAdvertisingInfo(id) {
        this.$loading()
        getInfo(id)
          .then((res) => {
            const { data, code } = res
            if (code === 0) {
              this.advertisingInfo = data
              this.editVisible = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
